<template>
  <div class="base-balldraw" :style="aStyle">
    <!-- 扭蛋区域 -->
    <div
      :class="{ egg_area: true, border: viewStatus != 2 }"
      :style="areaStyle"
    >
      <div ref="eggBody">
        <div
          class="egg_box"
          v-for="(item, index) in eggValue"
          :style="calcStyle(index)"
          :class="`egg_box${index + 1}`"
          :key="index"
        >
          <img :src="`${item}`" />
        </div>
      </div>
    </div>
    <!-- 按钮 -->
    <div class="btn-lottery" :style="btnStyle" @click="toStart"></div>
    <!-- 扭蛋下落 -->
    <div
      class="bounce-down-ball"
      v-show="showPrizeBox"
      :style="downStyle"
    ></div>
  </div>
</template>

<script>
// import { getRandomArbitrary } from '@utils/index';
const muduleBgWidth = 582;
const muduleBgHeight = 783;
const btnWidth = 176;
const btnHeight = 181;
export default {
  name: 'BaseBalldraw',
  props: {
    prizeList: {
      required: true
    },
    draw: {
      type: Object,
      default: () => {}
    },
    egg: {
      required: true
    },
    viewStatus: {
      type: Number
    }
  },
  data() {
    return {
      moveIng: false,
      showPrizeBox: false, // 出奖 是否显示
      width: muduleBgWidth,
      height: muduleBgHeight,
      btnWidth,
      btnHeight,
      mValue: undefined,
      listValue: [],
      defaultBtn:
        'https://cdn-tx-admin-test.3kwan.com/2023/07/06/e6e11a3bf4665e106153884dd107407c.png',
      defaultBg:
        'https://cdn-tx-admin-test.3kwan.com/2023/07/06/de861afb5f9598e2f5bb932e56b66017.png',
      defaultPrizeEgg: '',
      styleCacheMap: {},
      eggValue: [],
      eggs: [],
      prizeEgg: ''
    };
  },
  watch: {
    draw: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.mValue = newVal;
        this.init();
      }
    },
    prizeList: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.listValue = newVal;
      }
    },
    egg: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.assembleEgg(newVal);
      }
    }
  },
  computed: {
    aStyle() {
      return {
        height: this.$unit(this.height),
        width: this.$unit(this.width),
        backgroundImage: `url(${this.draw.bg || this.defaultBg})`
      };
    },
    btnStyle() {
      return {
        height: this.$unit(this.btnHeight),
        width: this.$unit(this.btnWidth),
        backgroundImage: `url(${this.draw.btn || this.defaultBtn})`,
        left: this.$unit(this.draw.btnLeft),
        bottom: this.$unit(this.draw.btnBottom)
      };
    },
    areaStyle() {
      return {
        height: this.$unit(this.draw.eggAreaHeight),
        width: this.$unit(this.draw.eggAreaWidth),
        left: this.$unit(this.draw.eggAreaLeft),
        top: this.$unit(this.draw.eggAreaTop)
      };
    },
    downStyle() {
      return {
        height: this.$unit(this.draw.prizeEggHeight),
        width: this.$unit(this.draw.prizeEggWidth),
        right: this.$unit(this.draw.prizeEggRight),
        bottom: this.$unit(this.draw.prizeEggBottom),
        backgroundImage: `url(${this.prizeEgg})`
      };
    },
    calcStyle() {
      return function (index) {
        // 作一次缓存处理
        if (
          Object.keys(this.styleCacheMap).length &&
          this.styleCacheMap[index]
        ) {
          return this.styleCacheMap[index];
        }
        this.styleCacheMap[index] = {
          width: '23.7%',
          height: '37.7%'
        };
        return this.styleCacheMap[index];
      };
    }
  },
  async mounted() {
    this.init();
    if (this.viewStatus != 2) {
      this.showPrizeBox = true;
    } else {
      this.showPrizeBox = false;
    }
  },
  methods: {
    init() {
      let img = new Image();
      img.onload = () => {
        let h = img.height;
        let w = img.width;
        this.height = h;
        this.width = w;
      };
      img.onerror = () => {
        this.height = muduleBgHeight;
        this.width = muduleBgWidth;
      };
      img.src = this.draw.bg;

      let btn = new Image();
      btn.onload = () => {
        let h = btn.height;
        let w = btn.width;
        this.btnHeight = h;
        this.btnWidth = w;
      };
      btn.onerror = () => {
        this.btnHeight = btnHeight;
        this.btnWidth = btnWidth;
      };
      btn.src = this.draw.btn;
    },
    randomPrizeEgg() {
      let random = Math.floor(Math.random() * (this.eggs.length - 1 + 1));
      this.prizeEgg = this.eggs[random];
    },
    assembleEgg(data) {
      let imgArr = [];
      let newArr = [];
      data.map((item) => {
        if (item.eggImg != undefined && item.eggImg != '') {
          imgArr.push(item.eggImg);
        }
      });
      for (let i = 0; i < 10; i++) {
        let element = imgArr[i % imgArr.length];
        newArr.push(element);
      }
      this.eggValue = newArr;
      this.eggs = imgArr;
    },
    async drawAni() {
      this.showPrizeBox = false;
      this.randomPrizeEgg();
      this.setNodeClass(true);
      await this.delay(1500);
      this.setNodeClass(false);
      // 页面滚动到顶部，保证动画在中
      // window.scroll(0, 0);
      this.playPrizeEgg();
    },
    // 出蛋
    async playPrizeEgg() {
      this.showPrizeBox = true;
      await this.delay(700);
      this.$emit('end-turns');
      await this.delay(1000);
      this.showPrizeBox = false;
    },
    async toStart() {
      this.$emit('start-turns');
    },
    // 节点class处理
    async setNodeClass(add = true) {
      const eggChild = this.$refs.eggBody.childNodes;
      for (let i = 0; i < 10; i++) {
        const itemBoxStyle = eggChild[i].style;
        add
          ? (itemBoxStyle.animation = `play${i + 1} 0.75s 6 linear`)
          : (itemBoxStyle.animation = '');
      }
      this.moveIng = add;
    },
    // 延迟函数
    async delay(time = 2000) {
      return new Promise((res) => {
        setTimeout(() => {
          res();
        }, time);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.egg_area {
  position: absolute;
  left: 54.5%;
  transform: translateX(-50%);
  width: 560px;
  height: 395px;
  background-color: transparent;
  top: 0;
  z-index: 1;
}
.egg_box {
  position: absolute;
}
.egg_box img {
  width: 100%;
}
/* ------- 10个蛋 -------   */
/* 前4个 */
.egg_box1 {
  left: 8%;
  top: 62.3%;
  z-index: 70;
  transform: rotate(-30deg);
}
.egg_box2 {
  left: 30%;
  top: 62.3%;
  z-index: 60;
  transform: rotate(85deg);
}
.egg_box3 {
  left: 53%;
  top: 62.3%;
  z-index: 50;
  transform: rotate(-10deg);
}
.egg_box4 {
  left: 72%;
  top: 62.3%;
  z-index: 70;
  transform: rotate(20deg);
}
/* 后四个 */
.egg_box5 {
  left: 64.4%;
  top: 40.4%;
  z-index: 40;
  transform: rotate(-65deg);
}
.egg_box6 {
  left: 44.2%;
  top: 46.4%;
  z-index: 30;
  transform: rotate(16deg);
}
.egg_box7 {
  left: 27.5%;
  top: 43.3%;
  z-index: 40;
  transform: rotate(-13deg);
}
.egg_box8 {
  left: 14.4%;
  top: 37.3%;
  z-index: 30;
  transform: rotate(46deg);
}
/* 后两个 */
.egg_box9 {
  left: 33.4%;
  top: 19.4%;
  z-index: 20;
  transform: rotate(65deg);
}
.egg_box10 {
  left: 53.6%;
  top: 26.5%;
  z-index: 10;
  transform: rotate(-92deg);
}

.prize-bg {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
}
.base-balldraw {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .btn-lottery {
    position: absolute;
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
}
.bounce-down-ball {
  position: absolute;
  bottom: 40px;
  right: 110px;
  width: 140px;
  height: 140px;
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: cover;
  animation-delay: 0;
  -webkit-animation-delay: 0;
  animation: bottomInDown 600ms linear;
}
.border {
  border: 2px solid red;
}
</style>
